module.exports = __webpack_public_path__ + "static/media/boxDark.371405df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/boxDark.svg
// module id = 78
// module chunks = 0